export default interface ShiftTypeRepositoryInterface {
  getAllShiftTypes(): Promise<ShiftTypeInterface[]>

  createShiftType(data: ApiCreateShiftTypeInterface): Promise<boolean>

  deleteShiftType(roleId: number): Promise<void>

  updateShiftType(id: string, data: ApiCreateShiftTypeInterface): Promise<void>

  calculateShiftDuration(start: string, end: string, breakDuration: number): number
}

export interface ShiftTypeInterface {
  id: number
  name: string
  shortName: string
  duration: number
  breakDuration: number
  startAt: string
  endAt: string
  textColor: string
  background: string
  dayType: string
  automations: boolean
}

export interface ApiCreateShiftTypeInterface {
  name: string
  shortName: string
  duration: number
  breakDuration: number
  startAt: string
  endAt: string
  textColor: string
  background: string
  dayType: string
  automations: boolean
}

export enum ShiftDayType {
  WORK = 'work',
  PAID = 'paid',
  UNPAID = 'unpaid',
  SICK = 'sick',
  ADDITIONAL_PAID = 'additional_paid',
  MARRIAGE = 'marriage',
  BLOOD_DONATION = 'blood_donation',
  FUNERAL = 'funeral',
  PATERNITY = 'paternity',
  OTHER = 'other',
}
